import { render, staticRenderFns } from "./MarketplaceProvidersViewAll.vue?vue&type=template&id=33106d17&scoped=true"
import script from "./MarketplaceProvidersViewAll.vue?vue&type=script&lang=js"
export * from "./MarketplaceProvidersViewAll.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceProvidersViewAll.vue?vue&type=style&index=0&id=33106d17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33106d17",
  null
  
)

export default component.exports